import _ from 'lodash';

import domains from '../containers/Domains';
import contextMakePost from './Context';

const endpoint = domains.fbEndpoint;

export const createAudience = async (data, token, isLookalike) => {
  let parameters = {
    access_token: token,
    pixel_id: data.pixel_id,
    name: data.name,
    retention_days: data.retention_days,
    rule: data.rule,
    prefill: 1
  };

  if (data.subtype) {
    parameters.subtype = data.subtype;
  }

  if (data.claim_objective) {
    parameters.claim_objective = data.claim_objective;
  }

  if (data.content_type) {
    parameters.content_type = data.content_type;
  }

  if (data.inclusions) {
    parameters.inclusions = data.inclusions;
  }

  if (data.exclusions) {
    parameters.exclusions = data.exclusions;
  }

  if (data.event_source_group) {
    parameters.event_source_group = data.event_source_group;
  }

  if (data.event_sources) {
    parameters.event_sources = data.event_sources;
  }

  if (isLookalike) {
    parameters = {
      origin_audience_id: data.origin_audience_id,
      name: data.name,
      lookalike_spec: data.lookalike_spec,
      subtype: data.isHecCampaign
        ? 'REGULATED_CATEGORIES_AUDIENCE'
        : 'LOOKALIKE',
      access_token: token
    };
    if (data.isHecCampaign) {
      delete parameters.lookalike_spec;
      parameters.regulated_audience_spec = data.lookalike_spec;
    }
  }

  const id = `act_${data.accountId}/customaudiences`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getAudiences = async (accountId, token) => {
  const parameters = {
    accountId,
    access_token: token,
    fields: 'id,name',
    limit: 2000
  };

  const allAudiences = Promise.all([
    new Promise(async (resolve, reject) => {
      const savedAudiencesQuery = _.template(
        `${endpoint}act_<%= accountId%>/saved_audiences?fields=<%= fields%>&access_token=<%= access_token%>&limit=<%= limit%>`
      );
      try {
        const savedAudiencesResult = await fetch(
          savedAudiencesQuery(parameters)
        );
        resolve(savedAudiencesResult.json());
      } catch (error) {
        reject(error);
      }
    }),
    new Promise(async (resolve, reject) => {
      const customAudiencesQuery = _.template(
        `${endpoint}act_<%= accountId%>/customaudiences?fields=<%= fields%>&access_token=<%= access_token%>&limit=<%= limit%>`
      );
      try {
        const customAudiencesResult = await fetch(
          customAudiencesQuery(parameters)
        );
        resolve(customAudiencesResult.json());
      } catch (error) {
        reject(error);
      }
    })
  ]);

  return allAudiences;
};

export const getDetailedTargeting = async (query, accountId, token) => {
  // TODO: the endpoint should look like `endpoint/act_<account_id>/targetingsearch?q=<query>
  // refer : https://developers.facebook.com/docs/marketing-api/targeting-search/#detailed at Detailed Targeting

  const targetingRequest = `${endpoint}act_${accountId}/targetingsearch?q=${query}&access_token=${token}`;

  const result = await fetch(targetingRequest);

  if (!result) {
    return {
      state: 500,
      error: {
        message: 'There was unknown error from facebook.'
      }
    };
  }

  return result.json();
};



// WEBPACK FOOTER //
// ./src/fbApi/Audience.js